import type { ColDef } from 'ag-grid-community'
import { BuyerCellRenderer } from '../renderers/BuyerCellRenderer'
import { InvoiceCountCellRenderer } from '../renderers/InvoiceCountCellRenderer'
import { BOLCountCellRenderer } from '../renderers/BOLCountCellRenderer'
import { SupplierNameCellRenderer } from '../renderers/SupplierNameCellRenderer'

export const supplierColumnDefs: ColDef[] = [
  {
    headerName: '',
    field: 'supplierId',
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: {
      suppressCount: true,
      padding: 0,
    },
    width: 40,
    minWidth: 40,
    maxWidth: 40,
    resizable: false,
    sortable: false,
    suppressMenu: true,
    pinned: 'left',
    suppressFiltersToolPanel: true,
  },
  {
    headerName: 'Supplier',
    field: 'supplierName',
    flex: 1,
    cellRenderer: SupplierNameCellRenderer,
    cellStyle: { textAlign: 'left' },
  },
  {
    headerName: 'Buyer',
    field: 'buyer',
    flex: 1,
    cellRenderer: BuyerCellRenderer,
    cellStyle: { textAlign: 'left' },
  },
  {
    headerName: 'Invoices',
    field: 'totalInvoices',
    flex: 0.7,
    cellStyle: { textAlign: 'center' },
    cellRenderer: InvoiceCountCellRenderer,
    filter: 'agNumberColumnFilter',
  },
  {
    headerName: 'BOLs',
    field: 'totalBOLs',
    flex: 0.7,
    minWidth: 80,
    cellStyle: { textAlign: 'center' },
    cellRenderer: BOLCountCellRenderer,
    filter: 'agNumberColumnFilter',
  },
  {
    headerName: 'Past Due',
    field: 'pastDueAmount',
    flex: 1,
    cellStyle: { textAlign: 'right', fontWeight: 'bold' },
    filter: 'agNumberColumnFilter',
    pinned: 'right',
    valueFormatter: (params) => {
      const amount = params.value || 0
      return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
  },
]
